import React, { Component } from "react";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getMTCampaignsList, getTikTokAdvertisersList, integrationStateInit } from "../../../store/integration/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class CampaignsMT extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getMTCampaignsList(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
    this.props.getMTCampaignsList(data);
  };

  render() {
    const columns = [
      {
        dataField: "campaign_id",
        text: "Campaign id",
        sort: true,
      },
      {
        dataField: "agency_name",
        text: "Agency name",
        sort: true
      },
      {
        dataField: "campaign_name",
        text: "Campaign name",
        sort: true
      }
    ];

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaigns MyTarget | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Campaigns MyTarget" link="/dashboard"/>
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CampaignsMT.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getMTCampaignsList: PropTypes.func.isRequired,
  integrationStateInit: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.Integration.dataCampaignsMT,
  loading: state.Integration.loading_campaigns_mytarget,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, { getMTCampaignsList, integrationStateInit })(
  CampaignsMT
);